import { tryNew } from '@/helpers/dto2resource';

import DividaDto from '../dto/DividaDto';
import SincronizacaoDto from '../dto/SincronizacaoDto';
import DividaResource from './DividaResource';
import PeriodoIndisponibilidadeResource from './PeriodoIndisponibilidadeResource';

interface InfoCredor {
  periodoIndisponibilidade?: PeriodoIndisponibilidadeResource;
}

export default class SincronizacaoResource {
  sincronizouDividas: boolean;
  dividas: DividaResource[];
  infoCredor: InfoCredor;

  constructor(dto: SincronizacaoDto) {
    this.sincronizouDividas = dto.sincronizouDividas;
    this.dividas = dto.dividas.map((d) => new DividaResource(d));

    this.infoCredor = {
      periodoIndisponibilidade: tryNew(
        PeriodoIndisponibilidadeResource,
        dto.periodoIndisponibilidade,
      ),
    };
  }

  static fromWhiteLabelApi(dto: DividaDto[]) {
    return new SincronizacaoResource({
      dividas: dto,
      sincronizouDividas: true,
    });
  }
}
